import React from 'react'

const handleInputWithRestrictions = (value: string, setFunc: React.Dispatch<React.SetStateAction<string>>): void => {
  if (!value.match(/[&/\\#,+()$~%'":*?<>{}\-^!;_@.]/)) {
    setFunc(value)
  }
}

export default handleInputWithRestrictions
